import React, { Component } from 'react'
import { css, StyleSheet } from 'aphrodite/no-important'

import { OldButton } from '../../../generic'
import {
  FamilyFeaturesSettings,
  FamilyLogDetailsSettings,
} from '../../../../screens/AccountsSettings/FamilySettings/components'
import { colors } from '@lmc/common/constants'
import { hexToRgbA } from '../../../../common/utils'
import { trackEvent } from '../../../../common/services/intercom'
import { isBrowser, isTablet } from 'react-device-detect'

interface FamilyPortalFeaturesProps {
  fields?: any
  home: any
  formId: string
  goToNextStep?: () => void
  preferredCarePlansNominative: string
  mixpanel: any // Define the type for mixpanel
}

export default class FamilyPortalFeatures extends Component<FamilyPortalFeaturesProps> {
  constructor(props: FamilyPortalFeaturesProps) {
    super(props)
  }

  myRef = React.createRef()

  onNext = () => {
    const { goToNextStep, mixpanel } = this.props
    trackEvent('CO_family_set_features')
    mixpanel.track('CO_family_set_features')
    goToNextStep?.()
  }

  render() {
    const {
      formId,
      fields = {},
      preferredCarePlansNominative,
      home,
    } = this.props

    return (
      <div className={css(classes.container)}>
        <h2 className={css(classes.header)}>Family Portal Setup</h2>
        <div className={css(classes.bodyText)}>
          Customise what families will be able to view in their Apps. These
          changes will be applied to all family members you have using the
          Family Portal.
        </div>
        <FamilyFeaturesSettings
          homeSettings={fields}
          formId={formId}
          preferredCarePlansNominative={preferredCarePlansNominative}
          features={home}
        />
        <FamilyLogDetailsSettings
          homeSettings={fields}
          formId={formId}
          isWhiteBackground
          featureOptionsStyle={{ paddingBottom: 60 }}
        />
        <div className="lmc-fixed-footer" style={styles.footer}>
          <div className={css(classes.footerSubContainer)}>
            <div className={css(classes.greyBodyText)}>
              Note: You can always change your settings at a later date
            </div>
            <OldButton
              onClick={() => this.onNext()}
              type="add"
              text="Next Step"
              style={styles.nextStepBtn}
            />
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  footer: {
    border: 'none',
    background: 'white',
    display: 'flex',
    justifyContent: 'center',
    width: isBrowser || isTablet ? 'calc(100vw - 290px)' : '100vw',
  },
  nextStepBtn: {
    height: 40,
    boxShadow: `0 0 8px ${hexToRgbA(colors.black, 0.2)}`,
  },
}

const classes = StyleSheet.create({
  bodyText: {
    lineHeight: '22px',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    maxWidth: 960,
    margin: 'auto',
  },
  footerSubContainer: {
    width: 960,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  greyBodyText: {
    color: colors.darkgrey,
    paddingRight: 16,
  },
  header: {
    lineHeight: '36px',
    alignSelf: 'center',
    marginBottom: 24,
  },
})
